// src/components/Services.js

import React, { useEffect, useState, useRef } from 'react';
import styles from './Services.module.css';

const SERVICES = [
  {
    title: 'Custom Software Development',
    description: 'Tailor-made applications built to meet your business goals.',
  },
  {
    title: 'Mobile App & Web Development',
    description: 'Seamless mobile and web solutions for Android, iOS & Web platforms.',
  },
  {
    title: 'Business Analytics',
    description: 'Gain insights through intelligent dashboards and data tools.',
  },
  {
    title: 'Business Consulting & Digital Marketing',
    description: 'Strategic advisory to start & optimise your business, tech operations and revenue generation ',
  },
  // {
  //   title: 'Training & Coaching',
  //   description: 'Empower your team with expert-led sessions and mentoring.',
  // },
  // {
  //   title: 'Resume Writing & Career Services',
  //   description: 'Professional CVs and coaching tailored for job seekers.',
  // },
];

const COLORS = ['#ffe0e0', '#e0f7ff', '#e0ffe6', '#fff5e0', '#e5e0ff', '#f5e0ff'];

const ServiceCard = ({ service, color }) => (
  <div className={styles.card} style={{ backgroundColor: color }}>
    <h3>{service.title}</h3>
    <p>{service.description}</p>
  </div>
);

const Services = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const scrollRef = useRef();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.servicestext}>Our Expertise</h2>

      <div
        className={`${styles.serviceContainer} ${isMobile ? styles.mobileScroll : styles.desktopGrid}`}
        ref={scrollRef}
      >
        {SERVICES.map((service, idx) => (
          <ServiceCard key={idx} service={service} color={COLORS[idx % COLORS.length]} />
        ))}
      </div>
    </div>
  );
};

export default Services;





// import React from 'react';
// import styles from './Services.module.css';

// const Services = () => {
//   return (
//     <section className={styles.services}>
//       <h2 className={styles.howwehelp}>How We Help</h2>

//       {/* Start work here */}
//       <div className={styles.grid}>
//         <div className={styles.card}>
//         <h2>Technology Consulting</h2>
//           <p>
//             Our technology consulting services drive digital innovation. 
//             We deliver tailored strategies to modernize operations, 
//             streamline processes, and implement emerging technologies. 
//             Transform your business with our expert tech solutions.
//           </p>
//         </div>

//         <div className={styles.card}>
//           <h2>Smart Digital Solutions</h2>
//             <p>
//             Leverage smart digital solutions for advanced automation and data driven decision making.
//             We specialize in developing intelligent systems and machine learning technologies,
//             empowering businesses to boost efficiency and accelerate growth.
//             </p>
//         </div>

//         <div className={styles.card}>
//         <h2>Growth Strategy Powered by Insights</h2>
//           <p>
//             Maximize business performance with growth strategy powered by insights. 
//             Utilizing advanced data analytics and predictive insights, 
//             we empower organizations to make informed decisions, optimize operations
//             and stay ahead in competitive markets.
//           </p>
//         </div>

//         <div className={styles.card}>
//         <h2>Hybrid Mobile & Web App</h2>
//         <p>
//           Accelerate your digital presence with robust hybrid mobile & web apps 
//           that combine native performance with the flexibility of web technologies.
//           We leverage powerful cross platform hybrid frameworks to build feature 
//           rich applications reducing time to market and development costs.
//         </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Services;
